<app-wheel-list-item *ngFor="let wheel of (wheels | maxItemsFilter:_maxItemCount | sortOptions: mainService.getActiveSort(ctx?.SortOptions):ctx['busy']); trackBy: mainService.trackByShoppingCartItem; let odd=odd;" [odd]="odd" [ctx]="ctx" [wheel]="wheel"></app-wheel-list-item>
<app-show-more-button [(currentItemCount)]="_maxItemCount" [showPerCount]="maxItems" [totalItemCount]="wheels.length"></app-show-more-button>
<div *ngIf="wheels && wheels.length === 0" class="row">
  <div class="col">
    <div class="alert alert-warning" role="alert">
      <i class="fas fa-exclamation-triangle"></i> Er bleven geen velgen over.
    </div>
  </div>
</div>
